import React from "react";
import { AIChatWidget, AIChatWidgetProps } from "./AIChatWidget";
import { StorageProvider } from "../../lib/storage/StorageContext";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import { WidgetErrorFallback } from "./WidgetErrorFallback";

/**
 * A version of AIChatWidget wrapped with StorageProvider and ErrorBoundary
 * This provides enhanced storage capabilities and error handling
 */
const AIChatWidgetWithStorage: React.FC<AIChatWidgetProps> = (props) => {
  return (
    <ErrorBoundary
      fallback={
        <WidgetErrorFallback
          primaryColor={props.primaryColor ?? "#007bff"}
          position={props.position ?? "right"}
          resetErrorBoundary={() => {
            // This will be handled by the parent component
            if (window.AIChatWidget?.initAIChatWidget) {
              window.AIChatWidget.initAIChatWidget({
                ...props,
              });
            }
          }}
        />
      }
      onError={(error, errorInfo) => {
        // Log the error
        console.error("Chat widget error:", error);
        console.error("Component stack:", errorInfo.componentStack);
      }}
    >
      <StorageProvider>
        <AIChatWidget {...props} />
      </StorageProvider>
    </ErrorBoundary>
  );
};

export default AIChatWidgetWithStorage;
